import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { PagesComponent } from './pages/pages.component';
import { AuthenticationGuard } from './projectservice/authentication.guard';
import { NotFoundComponent } from './pages/miscellaneous/not-found/not-found.component';

export const routes: Routes = [
  {
    path: 'voicepanel',
    component: PagesComponent,
    canActivate: [AuthenticationGuard],canActivateChild:[AuthenticationGuard],
    children: [
      {
        path: 'livecall',
        loadChildren: () => import('./pages/projectview/livecalls/livecalls.module').then(m => m.LiveCallModule)
      },
      {
        path: 'calllog',
        loadChildren: () => import('./pages/projectview/calllog/calllog.module').then(m => m.CallLogModule)
      },
      {
        path: 'callflow',
        loadChildren: () => import('./pages/projectview/callflow/callflow.module').then(m => m.CallFlowModule)
      },
      {
        path: 'settings',
        loadChildren: () => import('./pages/projectview/settings/settings.module').then(m => m.SettingsModule)
      },
      {
        path: 'voicemail',
        loadChildren: () => import('./pages/projectview/voicemail/voicemail.module').then(m => m.VoiceMailModule)
      },
      {
        path: 'blacklist',
        loadChildren: () => import('./pages/projectview/blacklist/blacklist.module').then(m => m.BlackListModule)
      },
      {
        path: 'manageuser',
        loadChildren: () => import('./pages/projectview/manageuser/mangeuser.module').then(m => m.ManageUserModule)
      },
      {
        path: 'manageagents',
        loadChildren: () => import('./pages/projectview/manageagents/manageagents.module').then(m => m.ManageAgentModule)
      },
      {
        path: 'click2call',
        loadChildren: () => import('./pages/projectview/click2call/click2call.module').then(m => m.Click2CallModule)
      },
      {
        path: 'click2callLog',
        loadChildren: () => import('./pages/projectview/click2calllog/click2calllog.module').then(m => m.Click2CallLogModule)
      },
      {
        path: 'officehours',
        loadChildren: () => import('./pages/projectview/officehours/officehours.module').then(m => m.OfficeHoursModule)
      },
      {
        path: '',
        redirectTo: 'livecall',
        pathMatch: 'full',
      },
      {
        path: '**',
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/loginpage/loginpage.module')
      .then(m => m.LoginPageModule),
  },
  {
    path: 'logout',
    loadChildren: () => import('./pages/logoutpage/logoutpage.module')
      .then(m => m.LogoutPageModule),
  },
  { path: '', redirectTo: 'voicepanel', pathMatch: 'full' },
  { path: '**', redirectTo: 'voicepanel' },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
